import React from "react";
import Header from "./Header/header";
import Footer from "./Footer/footer";
import ProgressBar from "./progressbar";

const SurveyWrapper = ({
  children,
  title = "ADVISOR MATCH SERVICE FEEDBACK",
  showProgressBar = true,
  showTitle = true,
  isThankYouPage = false,
  values = {},
}) => {
  return (
    <div>
      <Header />
      <section className="multi-bg">
        <div className="container" id="formcontainer">
          <div className="row">
            <div className="col-12">
              <div className="form-start text-center">
                {showTitle && (
                  <h1
                    className={
                      isThankYouPage
                        ? "step-heading thanks-heading"
                        : "step-heading"
                    }
                  >
                    {title.split("\n").map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        {index < title.split("\n").length - 1 && <br />}
                      </React.Fragment>
                    ))}
                    <hr />
                  </h1>
                )}
                {showProgressBar && <ProgressBar values={values} />}
                <form id="helpdeskform" name="helpdeskform" method="post">
                  {children}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SurveyWrapper;
